import { useState } from "react";
import { Modal } from "antd";
import styles from "./RenderError.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { hide } from "redux-modal";
import { RootState } from "@store";
import { IS_DEBUG } from "../../../config";

interface IRenderErrorProps {
  readonly componentStack?: string;
}

export default function RenderError({ componentStack }: IRenderErrorProps) {
  const dispatch = useDispatch();
  const modal = useSelector((state: RootState) => state.modals);
  const [open, setOpen] = useState<boolean>(true);

  const onClose = () => {
    const modals = Object.keys(modal);
    if (modals.length) {
      modals.forEach((m) => dispatch(hide(m)));
    }
    setOpen(false);

    window.location.reload();
  };

  const errorMsg = IS_DEBUG
    ? new Error(componentStack).stack
    : "Some error has occured. Please try again later or contact the administrator.";

  return (
    <Modal
      title={"Error has occurred!"}
      footer={null}
      onCancel={onClose}
      open={open}
      maskClosable={false}
      destroyOnClose
      centered
    >
      <div className={styles.wrapper}>
        <div className={styles.errorContent}>
          <p>{errorMsg}</p>
        </div>
      </div>
    </Modal>
  );
}
